import { Loader2 } from 'lucide-react'

export function Loader() {
  return (
    <div className="flex h-full items-center justify-center py-16">
      <Loader2 className="h-10 w-10 animate-spin text-primary" />
    </div>
  )
}
